import React, { Component } from 'react';
import { connect } from 'react-redux';
import {} from 'opentok-screen-sharing';
import { createSession } from 'opentok-react';
import Publisher from './Publisher';
import Subscriber from './Subscribers';
import ClassRoomSubscribers from './ClassRoomSubscribers';
import { myLog } from '../../../../utils/Utility';
import profileImg from '../../../../utils/images/profileImg.png';
import store from '../../../../sessionStorage';
import { streamFocusBroadCast } from '../../../action/VideoCallAction';
import { LevelTwoAdmin } from '../../../../utils/common/NamingTerms';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveVisitOpenTok extends Component {
    constructor(props) {
        super(props);
        this.state = {
            streams: [],
            openTokScreenShare: false,
        };
    }

    /**
     * @inheritDoc
     */
    componentWillMount() {
        const { apiKey, sessionId, token } = this.props;
        this.sessionHelper = createSession({
            apiKey,
            sessionId,
            token,
            onStreamsUpdated: (streams) => {
                this.setState({ streams }, () => {
                    this.props.onCallbackStreams(streams);
                });
            },
            // Without these two the result of session.connect() is thrown away, so a
            // bad/expired token or a network failure leaves the call silently dead -
            // every mute click then reports "connection is getting established" with
            // nothing in the console to explain why.
            onConnect: () => {
                console.log('[OpenTok Connected][session]', {
                    visitId: this.props.visitId,
                    sessionId,
                    visitType: store.get('VISIT_TYPE'),
                    sessionType: sessionStorage.getItem('SESSION_TYPE'),
                    credentialSource: this.props.credentialSource || 'unknown',
                });
            },
            onError: (error) => {
                console.error('[OpenTok ERROR][session.connect failed]', {
                    visitId: this.props.visitId,
                    sessionId,
                    name: error?.name,
                    code: error?.code,
                    message: error?.message,
                    credentialSource: this.props.credentialSource || 'unknown',
                });
            },
        });

        // Ensure stream property changes (like audio mute/unmute) are reflected
        // in the parent components by listening to the underlying OpenTok
        // session's `streamPropertyChanged` event and rebroadcasting the
        // updated streams list via `onCallbackStreams`.
        const session = this.sessionHelper && this.sessionHelper.session;
        if (session && typeof session.on === 'function') {
            // NEW: Listen for connection events (join/rejoin) - the authoritative trigger
            // This fires on EVERY connect, including rejoins, regardless of whether
            // the userId was already in the roster (studentDetails.sessionUsers).
            session.on('connectionCreated', (event) => {
                if (session.connection && event.connection.id === session.connection.id) {
                    return; // Ignore our own connection
                }
                // console.log('[OpenTok] connectionCreated - participant joined/rejoined, resyncing streamIds', {
                //     connectionId: event.connection.id,
                // });
                // Stream negotiation can lag behind the connection event,
                // so retry multiple times to catch late-arriving streams
                setTimeout(() => this.emitStreamId(), 800);
                setTimeout(() => this.emitStreamId(), 3000);
            });

            session.on('connectionDestroyed', (event) => {
                // console.log('[OpenTok] connectionDestroyed - participant left', {
                //     connectionId: event.connection.id,
                // });
            });

            session.on('streamPropertyChanged', (event) => {
                // React to audio/video toggles so UI (PatientInformation,
                // ParticipantContent, etc.) gets fresh hasAudio/hasVideo values.
                if (
                    event &&
                    event.stream &&
                    (event.changedProperty === 'hasAudio' ||
                        event.changedProperty === 'hasVideo')
                ) {
                    this.setState(
                        (prevState) => {
                            const updatedStreams = prevState.streams.map((stream) =>
                                // Match by the OpenTok stream id when available
                                stream &&
                                (stream.id === event.stream.id ||
                                    stream.streamId === event.stream.id)
                                    ? event.stream
                                    : stream
                            );
                            return { streams: updatedStreams };
                        },
                        () => {
                            this.props.onCallbackStreams(this.state.streams);
                        }
                    );
                }
            });
        }

        window.addEventListener('resize', this.resize.bind(this));
        this.resize();
    }

    /**
     * @inheritDoc
     */
    componentWillUnmount() {
        this.sessionHelper.disconnect();
    }

    //resize
    resize() {
        myLog('window', window);
        // this.setState({hideNav: window.innerWidth <= 760});
    }

    //takeScreenShot
    takeScreenShot() {
        return this.Subscriber.onScreenShot();
    }

    //onMuteVideo
    onMuteVideo(muteVideo, callback) {
        this.Publisher.onMuteVideo(muteVideo, (response) => {
            callback(response);
        });
    }

    //onToggleBackgroundBlur
    onToggleBackgroundBlur(enable, callback) {
        this.Publisher.onToggleBackgroundBlur(enable, (response) => {
            callback(response);
        });
    }

    //onMuteVoice
    onMuteVoice(muteVoice, callback) {
        this.Publisher.onMuteAudio(muteVoice, (response) => {
            callback(response);
        });
    }

    // muteStudentAudio
    muteStudentAudio(streamId) {
        let sessionDetails = this.sessionHelper;
        if (streamId && this.state.streams && this.state.streams.length) {
            let stream = this.state.streams.find((e) => e.streamId === streamId);
            sessionDetails.session.forceMuteStream(stream);
        }
    }

    // muteStudentVideo
    muteStudentVideo(streamId) {
        let sessionDetails = this.sessionHelper.session;
        if (streamId && this.state.streams && this.state.streams.length) {
            let stream = this.state.streams.find((e) => e.streamId === streamId);
            sessionDetails.signal(
                {
                    type: 'muteVideo',
                    data: JSON.stringify({
                        connectionId: stream.connection.id,
                    }),
                },
                (error) => {
                    if (error) {
                        console.error('Error sending signal:', error);
                    }
                }
            );
        }
    }

    // removeStudentStream
    removeStudentStream(streamId, callback) {
        let sessionDetails = this.sessionHelper.session;
        if (streamId && this.state.streams && this.state.streams.length) {
            let stream = this.state.streams.find((e) => e.streamId === streamId);
            sessionDetails.signal(
                {
                    type: 'removeStudentStream',
                    data: JSON.stringify({
                        connectionId: stream.connection.id,
                    }),
                },
                (error) => {
                    if (error) {
                        console.error('Error sending signal:', error);
                    }
                }
            );
            callback(true);
        }
    }

    // onRaiseHand
    onRaiseHand(raiseHand, callback) {
        this.Publisher.onRaiseHand(raiseHand, (response) => {
            callback(response);
        });
    }
    
    // Re-emit stream ID when new user joins
    emitStreamId() {
        // Emit Publisher's own streamId
        if (this.Publisher && typeof this.Publisher.emitMyStreamId === 'function') {
            this.Publisher.emitMyStreamId();
        }
        
        // Also emit streamIds for all remote streams in ClassRoomSubscribers
        if (this.ClassRoomSubscribers && typeof this.ClassRoomSubscribers.logStreamAndUserId === 'function') {
            this.ClassRoomSubscribers.logStreamAndUserId();
        }
    }

    //onscreenShare
    onscreenShare(shareScreen, callback) {
        this.Publisher.onscreenShare((response) => {
            callback(response);
        });

        this.setState({ openTokScreenShare: shareScreen });
        const visitType = store.get('VISIT_TYPE');
        const shouldUseClassRoomSubscribers =
            visitType === 'class_room' || visitType === 'class_room_session' ||
            visitType === 'conference_call' ||
            this.props.sessionTypeParamsGroup ||
            this.props.OwnerAsCollaborator;

        if (shouldUseClassRoomSubscribers && this.ClassRoomSubscribers?.onscreenShare) {
            this.ClassRoomSubscribers.onscreenShare(shareScreen, (response) => {});
        } else if (visitType !== 'broadcast' && this.Subscriber?.onscreenShare) {
            this.Subscriber.onscreenShare(shareScreen, (response) => {});
        }
    }

    // cancelScreenshare
    cancelScreenshare = (value) => {
        this.props.cancelScreenshare(value);
    };

    // muteForceStudent
    muteForceStudent = (value) => {
        this.props.muteForceStudent(value);
    };

    //muteVideoStudent
    muteVideoStudent = (value) => {
        this.props.muteVideoStudent(value);
    };

    //streamLayoutBroadCast
    streamLayoutBroadCast = (streamId) => {
        if (sessionStorage.getItem('VISIT_TYPE') === 'broadcast' && streamId) {
            let values = {
                sessionId: this.props.sessionId,
                streamId,
            };
            this.props.streamFocusBroadCast(values, (callBack) => {});
        }
    };

    render() {
        const isClassRoom = store.get('VISIT_TYPE') === 'class_room';
        const isBroadCast = store.get('VISIT_TYPE') === 'broadcast';
        const isOneToOne = store.get('VISIT_TYPE') === 'one_to_one';
        const isConferenceCall = store.get("VISIT_TYPE") === "conference_call";


        // Determine if any stream is a screen share
        const hasScreenShare =
            this.state.streams &&
            this.state.streams.some(
                (stream) => stream.videoType === 'screen' || stream.name === 'screen'
            );

        return (
            <>
                <div>
                    <Publisher
                        visitId={this.props.visitId}
                        ref={(ref) => (this.Publisher = ref)}
                        sessionHelper={this.sessionHelper}
                        session={this.sessionHelper.session}
                        apikey={this.props.apikey}
                        sessionId={this.props.sessionId}
                        role={this.props.role}
                        showMessagePop={this.props.showMessagePop}
                        showParticipants={this.props.showParticipants}
                        fullScreenEnabled={this.props.fullScreenEnabled}
                        messageClicked={this.props.messageClicked}
                        minWidth={this.props.minWidth}
                        cancelScreenshare={this.cancelScreenshare}
                        streamLayoutBroadCast={this.streamLayoutBroadCast}
                        muteForceStudent={this.muteForceStudent}
                        muteVideoStudent={this.muteVideoStudent}
                        navigateToSummary={this.props.navigateToSummary}
                        isInitialCallLoader={this.props.isInitialCallLoader}
                        isClassRoom={isClassRoom}
                        isBroadCast={isBroadCast}
                        isConferenceCall={isConferenceCall}
                        sessionTypeParamsGroup={this.props.sessionTypeParamsGroup}
                        userType={this.props.userType}
                        streams={this.state.streams}
                        renderLogoWithWifi={this.props.renderLogoWithWifi}
                        showWhiteboard={this.props.showWhiteboard}
                        isWhiteboardOpen={this.props.isWhiteboardOpen}
                        videoCallDetails={this.props.videoCallDetails}
                        studentDetails={this.props.studentDetails}
                        callpatientUserId={this.props.callpatientUserId}
                        calldoctorUserId={this.props.calldoctorUserId}
                        userId={this.props.userId}
                        hasUrlParams={this.props.hasUrlParams}
                        isOneToOne={isOneToOne}
                        sessionTypeParams={this.props.sessionTypeParams}
                        hasScreenShare={hasScreenShare}
                        credentialSource={
                            this.props.sessionJoinSource || this.props.credentialSource
                        }
                    />
                    {this.props.isMute ? (
                        <>
                            {isClassRoom ||
                            this.props.OwnerAsCollaborator ||
                            this.props.sessionTypeParamsGroup || isConferenceCall ? (
                                <ClassRoomSubscribers
                                    videoCallDetails={this.props.videoCallDetails}
                                    studentDetails={this.props.studentDetails}
                                    totalUser={this.props.totalUser}
                                    ref={(ref) => (this.ClassRoomSubscribers = ref)}
                                    streams={this.state.streams}
                                    sessionHelper={this.sessionHelper}
                                    apiKey={this.props.apikey}
                                    sessionId={this.props.sessionId}
                                    screenShare={this.state.openTokScreenShare}
                                    fullScreenEnabled={this.props.fullScreenEnabled}
                                    role={this.props.role}
                                    renderLogoWithWifi={this.props.renderLogoWithWifi}
                                    showMessagePop={this.props.showMessagePop}
                                    showParticipants={this.props.showParticipants}
                                    messageClicked={this.props.messageClicked}
                                    minWidth={this.props.minWidth}
                                    showWhiteboard={this.props.showWhiteboard}
                                    isWhiteboardOpen={this.props.isWhiteboardOpen}
                                    OwnerAsCollaborator={this.props.OwnerAsCollaborator}
                                    visitId={this.props.visitId}
                                    callpatientUserId={this.props.callpatientUserId}
                                    calldoctorUserId={this.props.calldoctorUserId}
                                    hasUrlParams={this.props.hasUrlParams}
                                    sessionTypeParamsGroup={this.props.sessionTypeParamsGroup}
                                    urlParams={this.props.urlParams}
                                    isConferenceCall={isConferenceCall}
                                />
                            ) : (
                                ((isBroadCast && this.props.role === LevelTwoAdmin) ||
                                    !isBroadCast ||
                                    this.props.sessionTypeParams) && (
                                    <Subscriber
                                        videoCallDetails={this.props.videoCallDetails}
                                        callpatientUserId={this.props.callpatientUserId}
                                        calldoctorUserId={this.props.calldoctorUserId}
                                        totalUser={this.props.totalUser}
                                        ref={(ref) => (this.Subscriber = ref)}
                                        streams={this.state.streams}
                                        sessionHelper={this.sessionHelper}
                                        apiKey={this.props.apikey}
                                        sessionId={this.props.sessionId}
                                        screenShare={this.state.openTokScreenShare}
                                        fullScreenEnabled={this.props.fullScreenEnabled}
                                        role={this.props.role}
                                        renderLogoWithWifi={this.props.renderLogoWithWifi}
                                        showWhiteboard={this.props.showWhiteboard}
                                        visitId={this.props.visitId}
                                        isWhiteboardOpen={this.props.isWhiteboardOpen}
                                        hasUrlParams={this.props.hasUrlParams}
                                        sessionTypeParams={this.props.sessionTypeParams}
                                    />
                                )
                            )}
                        </>
                    ) : (
                        <div className="circle-img-video">
                            <img
                                src={
                                    this.props.profileImage === ''
                                        ? profileImg
                                        : this.props.profileImage
                                }
                                className="video-circle-img"
                                alt=""
                            />
                        </div>
                    )}
                </div>
            </>
        );
    }
}

const mapDispatchtoProps = (dispatch) => {
    return {
        streamFocusBroadCast: (values, callBack) => {
            dispatch(streamFocusBroadCast(values, callBack));
        },
    };
};

export default connect(null, mapDispatchtoProps, null, { forwardRef: true })(ActiveVisitOpenTok);
